import React, { useEffect } from 'react';
import { Navbar, Hero, About, Rules, Timeline, Awards, Register } from './components';
import FinalSection from './components/FinalSection';
import './index.css';

function App() {
  useEffect(() => {
    // Função para detectar a região com base na URL ou hostname
    const detectarRegiao = () => {
      const url = window.location.href.toLowerCase();
      const hostname = window.location.hostname.toLowerCase();
      let regiao = "";
      
      // Verificar domínios específicos primeiro
      if (hostname.includes('apachackathon') || hostname === 'apachackathon.happy.com.br') {
        regiao = "APAC";
      } else if (hostname.includes('apshackathon') || hostname === 'apshackathon.happy.com.br') {
        regiao = "APS";
      } else if (hostname.includes('advnordestehackathon') || hostname === 'advnordestehackathon.happy.com.br') {
        regiao = "Nordeste";
      } 
      // Se não encontrou por hostname, tenta encontrar por parâmetros na URL
      else if (url.includes('apac') || url.includes('asia') || url.includes('pacifico')) {
        regiao = "APAC";
      } else if (url.includes('aps') || url.includes('america') || url.includes('sul')) {
        regiao = "APS";
      } else if (url.includes('nordeste') || url.includes('ne') || url.includes('northeast')) {
        regiao = "Nordeste";
      }
      
      // Se encontrou uma região, atualizar o título e o atributo data-regiao
      if (regiao) {
        document.title = `Hackathon Happy Escolas 2025 - ${regiao}`;
        document.documentElement.setAttribute('data-regiao', regiao);
      }
    };
    
    // Executar a detecção de região
    detectarRegiao();

    // Função para navegar para a âncora na URL
    const navigateToHash = () => {
      const hash = window.location.hash;
      if (hash) {
        // Pequeno atraso para garantir que todos os componentes foram renderizados
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    };

    // Executa ao montar o componente
    navigateToHash();

    // Também executa quando o hash muda
    window.addEventListener('hashchange', navigateToHash);

    // Limpa o event listener quando o componente é desmontado
    return () => {
      window.removeEventListener('hashchange', navigateToHash);
    };
  }, []);

  return (
    <div className="App" style={{ overflow: 'hidden', maxWidth: '100vw' }}>
      <div className="min-h-screen bg-gray-100">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Register />
          <Timeline />
          <Awards />
          <Rules />
          <FinalSection />
        </main>
      </div>
    </div>
  );
}

export default App;
